import React, { ReactChild, useState } from "react";
import { Sidebar } from "./Sidebar";
import { SubNavbar } from "./SubNavbar";

export const NavbarLanding = ({
  logo,
  navLeft,
  navRight,
  navCenter,
  sidebarRight,
  subNav,
  setToggleSidebar,
  toggleSidebar,
}: {
  logo: ReactChild;
  navLeft?: ReactChild;
  navRight: ReactChild;
  navCenter?: ReactChild;
  sidebarRight: ReactChild;
  subNav?: ReactChild;
  setToggleSidebar?: (toggleSidebar: boolean) => void;
  toggleSidebar?: boolean;
}) => {
  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-light bg-light gradient-light fixed-top">
        <div className="container">
          <div className={"d-flex w-100 align-items-center"}>
            {navLeft}
            <div className="navbar-brand ml-auto">{logo}</div>
            {navRight}
          </div>
          <div id="navbarSupportedContent">
            <div className="row">
              <div className="col">{navCenter}</div>
              <div className="col-auto ml-auto">
                <div className="ml-auto nav-right"></div>
              </div>
            </div>
          </div>
        </div>
        {subNav && <SubNavbar>{subNav}</SubNavbar>}
        {sidebarRight && (
          <Sidebar
            isVisible={toggleSidebar || false}
            hideSidebarHandler={() =>
              setToggleSidebar && setToggleSidebar(!toggleSidebar)
            }
          >
            {sidebarRight}
          </Sidebar>
        )}
      </nav>
    </>
  );
};
